import { Breadcrumb, Card, EventHandler, PrimaryButton, Search, SofturaTable } from "client/CommonComponents"
import moment from "moment"
import { DateRangePicker } from "rsuite"
import excel from '../../../../assets/images/Excel.svg'
import './DispositionPenaltyFee.scss'

const DispositionPenalty = (props:any) => {

    const {
        gridData,
        searchValue,
        dateRange,
        onSearchOrder,
        onDateRangeChange,
        reportsColumns,
        setFilters,
        serverTotal,
        fetchAction,
        pagesCount,
        handleFilterClear,
        showGrid,
        onExportExcel,
        handleClickBack,
        alreadyHasGridFilterValues
      } = props;

    return(
        <div className='CustomerMyOrder breadCrumbBlock mt-1'>
            <div className='breadcrumb-toolbar'>
                <EventHandler onEvent={(e: any) => handleClickBack(e)} data-attribute="DispositionPenaltyFee_Default_EventHandler">
                    <div className='backButton mb-sm-0 mb-3'>
                        <span className="fa fa-chevron-left"></span> Back
                    </div>
                </EventHandler>
                <div className='order-1'><Breadcrumb items={props.breadcrumlist} maxDisplayedItems='5'  data-attribute="DispositionPenaltyFee_Default_Breadcrumb" /></div>
            </div>
            <Card data-attribute="DispositionPenaltyFee_Default_Card">
                <div className='grid-block pt-2'>
                    <div className='mb-1 top-section'>
                        <p className='mt-1'>REPORTS</p>
                        <div className='clearfix mt-2 mb-3'>
                            <div className='pull-left searchblock report'>
                                <Search
                                    placeholder='Search By Order#, Asset#'
                                    className='searchTextbox'
                                    onSearch={(e?: any) => onSearchOrder(e, true)}
                                    onBlur={(e?: any) => onSearchOrder(e, false)}
                                    onChange={(e?: any) => onSearchOrder(e, false)}
                                    value={searchValue}
                                 data-attribute="DispositionPenaltyFee_Default_Searchbox" />
                            </div>
                            <div className='pull-right datepickerControl mb-2 mb-sm-0 mt-sm-0 mt-2'>
                                <DateRangePicker
                                    placement='bottomEnd'
                                    format="MM/dd/yyyy"
                                    character=' - '
                                    onChange={onDateRangeChange}
                                    placeholder='MM/DD/YYYY - MM/DD/YYYY'
                                    preventOverflow={true} value={dateRange}
                                    defaultCalendarValue={[new Date(moment().startOf('month').toDate()), new Date(moment().add(1, 'months').startOf('month').toDate())]}
                                     data-attribute="DispositionPenaltyFee_Default_DateRangePicker" />
                                <PrimaryButton text='Clear Filters' disabled={alreadyHasGridFilterValues()} onClick={handleFilterClear} className='filter-btn'  data-attribute="DispositionPenaltyFee_Default_Button" />
                                <div className='excel-section report'>
                                    <EventHandler onEvent={onExportExcel} data-attribute="DispositionPenaltyFee_Default_EventHandler_2">
                                        <img src={excel} alt='excel' />
                                    </EventHandler>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`report-listing-grid pe-0 ${gridData?.length != 0 ? "softura-table" : "softura-table paginationNav"}`}>
                        {showGrid && <SofturaTable
                            data={gridData ?? []}
                            columns={reportsColumns}
                            sort={true}
                            defaultPageSize={10}
                            getFilterValue={setFilters}
                            pageSizes={[10, 20, 50]}
                            globalSearch={false}
                            filter={true}
                            defaultPaginationPosition='Both'
                            fixedHeader={true}
                            serverTotal={serverTotal}
                            fetchAction={fetchAction}
                            isServerSide={true}
                            pagesCount={pagesCount}
                         data-attribute="DispositionPenaltyFee_Default_Grid" />}
                    </div>
                </div>
            </Card>   
        </div>      
    )
}

export default DispositionPenalty